import React from 'react'
import { useTranslation } from 'react-i18next'

import { ResidentAppIllustration } from 'components/ResidentAppIllustration'
import Success from 'components/Success'

export const AddTenantSuccess: React.FC = () => {
  const { t } = useTranslation(['common', 'contractModification'])

  return (
    <Success
      illustration={
        <ResidentAppIllustration
          name="house-bye"
          alt={t('common:alt.illustration')}
          className="-ml-2"
        />
      }
      heading={t('common:thankYou')}
      text={t('contractModification:confirmationState.addTenantSuccess')}
    />
  )
}
